import * as types from './constants';
import * as utils from "../utils";
import update from 'immutability-helper';

const rsvp = window.evite_event.rsvp;
const event_options = window.evite_event.options;
const altGuestName = rsvp ? rsvp.name : "";
const initialState = {
  showForm: window.is_preview ? true : !utils.hasRsvpd(),
  showModal: false,
  showChangeRsvp: false,
  preventRsvp: Boolean(utils.eventHasPassed() || window.evite_event.status === "cancelled" || window.is_preview),
  formSubmitting: false,
  hasRsvpd: utils.hasRsvpd(),
  inGuestlist: rsvp ? true : false,
  rsvpResponse: rsvp && utils.hasRsvpd() ? rsvp.response : "yes",
  guestId: window.guest_id,
  guestName: rsvp ? rsvp.name : "",
  altGuestName: window.user_is_registered ? "" : altGuestName,
  guestEmail: rsvp ? rsvp.email : "",
  storedGuestId: "",
  storedGuestName: "",
  storedGuestEmail: "",
  totalAdults: rsvp ? rsvp.number_of_adults : 1,
  totalKids: rsvp ? rsvp.number_of_kids : 0,
  promptForGuestCount: rsvp ? !Boolean(rsvp.guest_of) : true,
  comment: "",
  allowGuests: event_options.event_option_allow_guest_number,
  allowKids: event_options.event_option_allow_kids,
  maxGuests: event_options.event_option_max_guest_number || 100,    // this is the number of *additional* people coming with the invited guest
  showNotifyMarketing: rsvp ? !rsvp.optin : true,
  showPlusOneOptions: !Boolean(rsvp && rsvp.guest_of) && Boolean(event_options.event_option_allow_guest_number) && Boolean(event_options.event_option_allow_invite_more),
  plusOneEmailsStr: rsvp ? rsvp.plus_one_emails_str : '',
  plusOneEditText: '',
  // if they have never opted out, the checkbox should be on
  notifyMarketing: rsvp ? rsvp.optin || !rsvp.optout : true,
  privateGuestlist: event_options.event_option_private_guestlist,
  isAnonymous: false,
  editingName: window.user_is_registered ? false : true,
  inviteMethod: rsvp && rsvp.invite_method || "",
};

function rsvpReducer(state=initialState, action) {
  switch (action.type) {
    case types.SHOW_RSVP_FORM:
      return update(state, {
        showForm: {$set: action.show},
        rsvpResponse: {$set: window.evite_event.rsvp.response},
        editingName: {$set: state.editingName}
      });
    case types.TOGGLE_RSVP_FORM_VISIBLE:
      return update(state, {
        showForm: {$set: !state.showForm},
        showModal: {$set: !state.showModal},
        rsvpResponse: {$set: action.response || (window.evite_event.rsvp ? window.evite_event.rsvp.response : state.rsvpResponse)},
        editingName: {$set: state.editingName}
      });
    case types.SET_FORM_SUBMITTING:
      return update(state, {
        formSubmitting: {$set: action.submitting}
      });
    case types.SET_INCOMPLETE_GUEST:
      return update(state, {
        inGuestlist: {$set: false},
      });
    case types.SET_NOT_YOU:
      return update(state, {
        guestId: {$set: ""},
        isAnonymous: {$set: true},
        inGuestlist: {$set: false},
        storedGuestId: {$set: state.guestId},
        storedGuestName: {$set: state.guestName},
        storedGuestEmail: {$set: state.guestEmail},
        guestName: {$set: ""},
        altGuestName: {$set: ""},
        guestEmail: {$set: ""},
        hasRsvpd: {$set: false}
      });
    case types.UNSET_NOT_YOU:
      return update(state, {
        guestId: {$set: state.storedGuestId},
        isAnonymous: {$set: false},
        inGuestlist: {$set: rsvp ? true : false},
        guestName: {$set: state.storedGuestName},
        altGuestName: {$set: state.storedGuestName},
        guestEmail: {$set: state.storedGuestEmail},
        hasRsvpd: {$set: utils.hasRsvpd()}
      });
    case types.SET_EDITING_GUEST_NAME:
      return update(state, {
        editingName: {$set: action.editing},
        altGuestName: {$set: action.guestName}
      });
    case types.SET_GUEST_NAME:
      return update(state, {
        guestName: {$set: action.guestName}
      });
    case types.SET_ALT_GUEST_NAME:
      return update(state, {
        altGuestName: {$set: action.altGuestName}
      });
    case types.SET_GUEST_EMAIL:
      return update(state, {
        guestEmail: {$set: action.guestEmail}
      });
    case types.SET_TOTAL_ADULTS:
      return update(state, {
        totalAdults: {$set: parseInt(action.adultCount, 10)}
      });
    case types.SET_TOTAL_KIDS:
      return update(state, {
        totalKids: {$set: parseInt(action.kidCount, 10)}
      });
    case types.SET_NOTIFY_MARKETING:
      return update(state, {
        notifyMarketing: {$set: action.notify}
      });
    case types.SET_RSVP_COMMENT:
      return update(state, {
        comment: {$set: action.comment}
      });
    case types.TOGGLE_CHANGE_RSVP_VISIBLE:
      return update(state, {
        showChangeRsvp: {$set: !state.showChangeRsvp},
      });
    case types.SET_RSVP_RESPONSE:
      return update(state, {
        rsvpResponse: {$set: action.response},
      });
    case types.SET_PLUSONE_EMAILS:
      return update(state, {
        plusOneEmailsStr: {$set: action.emailsStr}
      });
    case types.SET_PLUSONE_EDIT_TEXT:
      return update(state, {
        plusOneEditText: {$set: action.editTextStr}
      });
    default:
      return state
  }
}

export default rsvpReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/reducers.es6